import { isValid } from 'date-fns'
import { Nullable } from '.'

export type Plain = 'date'

export type Config = {
  type: 'date'
} & (
  | {
      nullable?: true
      defaultValue?: Date
    }
  | {
      nullable: false
      defaultValue: Date
    }
)

export type PlainResult = Date
export type Result<T extends Config> = Nullable<T, Date>

const transformValue = (value: any, config?: Config): Date | null => {
  if (value instanceof Date) {
    return value
  }

  const nullable = config?.nullable ?? true
  const defaultValue = (nullable ? config?.defaultValue : (config?.defaultValue as Date)) ?? null

  const parsed = new Date(value)

  if (typeof value !== 'string' || !isValid(parsed)) {
    return defaultValue
  }

  return parsed
}

export const transform = (value: any, config?: Config | Plain): Date | null => {
  if (config === 'date') {
    return transformValue(value)
  }

  return transformValue(value, config)
}
